<template>
  <div class="reserve" >
    <div class="reserve-title">优惠券设置</div>
    <div class="com-content" :class="{'comContentMargin': creationMode}" v-for="(item, index) in couponData" :key="index">
      <div class="collapse-head">
        <div class="left">
          优惠券场次{{index+1}}设置 
          <van-icon name="question-o" @click="tipsPop"/>
        </div>
        <div class="right" @click="delTime(index)" v-if="couponData.length > 1 && !isEditCoupon">删除</div>
      </div>
     
      <van-field
        v-model="item.startTime"
        readonly
        required
        label-width="8em"
        label="优惠券开始时间"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
        @click="choiceTime(index,'startTime')"
      />
      <van-field
        v-model="item.endTime"
        readonly
        required
        label-width="8em"
        label="优惠券结束时间"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
        @click="choiceTime(index,'endTime')"
      />
      <van-field
        v-model="item.deadline"
        readonly
        required
        label-width="8em"
        label="兑奖截止时间"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
        @click="choiceTime(index,'deadline')"
      />

      <div class="coupon-box" v-for="(childItem, childIndex) in item.couponTickets">
        <div class="head-box">
          <div class="head-left">优惠券 {{ childIndex+1 }}</div>
          <div class="head-left" v-if="!isEditCoupon">
            <span class="del" @click="delCoupon(index,childIndex)">删除</span>
            <span class="edit" @click="editCoupon(index, childIndex, childItem)">编辑</span>
          </div>
        </div>
        <div class="row">
          <div class="key">优惠券名称：</div>
          <div class="value">{{ childItem.couponName }}</div>
        </div>
        <div class="row">
          <div class="key">优惠券面值：</div>
          <div class="value">{{ childItem.couponFaceValue }}元</div>
        </div>
        <div class="row">
          <div class="key">使用门槛：</div>
          <div class="value">{{ childItem.useDoorsill }}张</div>
        </div>
        <div class="row">
          <div class="key">优惠券总数量：</div>
          <div class="value">{{ childItem.couponSum }}张</div>
        </div>
        <div class="row">
          <div class="key">每人最多领取数量：</div>
          <div class="value">{{ childItem.everyoneMaxGetNumber }}张</div>
        </div>
        <div class="row">
          <div class="key">使用规则：</div>
          <div class="value">{{ childItem.useRule }}</div>
        </div>
      </div>

      <div class="add-goods-btn" @click="addCoupon(index)" v-if="!isEditCoupon">添加优惠券</div>
    </div>
    <div class="add-range-btn" @click="addCouponTime" v-if="!isEditCoupon">新增场次</div>
    <van-popup v-model="isTimePopup" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择时间"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>

    <add-coupon-pop 
      :isShowAddCouponPop.sync="isShowAddCouponPop"
      :coupon.sync="coupon"
      @addSucess="addSucess"
    />
  </div>
  
</template>

<script>
  import dayjs from "@/utils/dayjs";
  import addCouponPop from './add-coupon-pop.vue';
  export default {
    components: { addCouponPop },
    props: {
      value:  {
        type: Array,
        default() {
          return {}
        }
      },
      basicInfoForm: {
        type: Object,
        default() {
          return {}
        }
      },
      isHasSignUp: {
        type: Boolean,
        default: true
      },
      isClone: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      couponData: {
        get() {
          return this.value
        },
        set(newVal, oldVal) {
          this.$emit('change',newVal)
        }
      },
      // 组件创建方式
      creationMode() {
        return this.$route.query.creationMode != 'new' ? true : false
      },
      isEditCoupon() {
      return this.$route.query.from == 'manager' ? true : false
    }
    },
    data() {
      return {
        activeNames: [],
        isShowAddCouponPop: false,
        isTimePopup: false,
        currentDate: new Date(),
        minDate: new Date(2024, 0, 1),
        maxDate: new Date(2030, 10, 1),

        currentTimeIndex: 0,
        currenTCouponIndex: 0,
        currentTimeField: '',
        coupon: {},
        isEdit: false,
      }
    },
    methods: {
      tipsPop(type) {
        this.$toast({
          duration: 5000,
          closeOnClickOverlay: true,
          message: '支持设置多个优惠券场次，各优惠券场次时间不能存在重叠，每个优惠券场次支持设置多个不同优惠券；',
        });
      },
      choiceTime(index, field) {
        if (this.isEditCoupon) return
        this.currentTimeIndex = index
        this.currentTimeField = field
        this.isTimePopup = true
      },
      confirm(e) {
        const timeGather = this.getTimeFragment()
        const time = dayjs(e).format("YYYY-MM-DD HH:mm:ss")
        const currentTimeItem = this.couponData[this.currentTimeIndex]
      

       switch(this.currentTimeField) {
        case 'startTime': 
          const iseXist = timeGather[this.currentTimeField].includes(time)
          if (iseXist) {
            this.$toast('当前时间段已经存在，请重新选择')
            return
          }
          if (dayjs(time).unix() > dayjs(currentTimeItem.endTime).unix()) {
            currentTimeItem.endTime = ''
            currentTimeItem.deadline = ''
          }
          break
        case 'endTime': 
          if (dayjs(time).unix() <= dayjs(currentTimeItem.startTime).unix()) {
            this.$toast('结束时间不能小于等于开始时间，请重新选择')
            return
          }
          break
        case 'deadline': 
          if (dayjs(time).unix() <= dayjs(currentTimeItem.endTime).unix()) {
            this.$toast('兑奖截止时间不能小于等于结束时间，请重新选择')
            return
          }
          break
       }
        currentTimeItem[this.currentTimeField] = time;
        this.isTimePopup = false
      },
      cancel() {
        this.isTimePopup = false
      },
      addCoupon(index) {
        this.coupon = {
          couponName: '',
          couponFaceValue: '',
          useDoorsill: '',
          couponSum: '',
          everyoneMaxGetNumber: '',
          useRule: '',
        }
        this.isEdit = false
        this.currentTimeIndex = index
        this.isShowAddCouponPop = true
      },
      addSucess(data) {
        if (this.isEdit) {
          this.couponData[this.currentTimeIndex].couponTickets[this.currenTCouponIndex] = data
        } else {
          this.couponData[this.currentTimeIndex].couponTickets.push(data)
        }
        
      },
      editCoupon(index,childIndex,childItem) {
        this.currentTimeIndex = index
        this.currenTCouponIndex = childIndex
        this.coupon = {...childItem}
        this.isEdit = true
        this.isShowAddCouponPop = true
      },
      delCoupon(index,childIndex) {
        this.$dialog.confirm({
          title: '提示',
          message: '确定要删除该优惠券吗？',
        }).then(() => {
          this.couponData[index].couponTickets.splice(childIndex, 1)
        })
      },
      addCouponTime() {
        this.couponData.push({
          startTime: '',
          endTime: '',
          deadline: '',
          couponTickets: []
        })
      },
      delTime(index) {
        this.$dialog.confirm({
          title: '提示',
          message: '确定要删除优惠券场次设置吗？',
        }).then(() => {
          this.couponData.splice(index, 1)
        })
      },
      // 获取时间段
      getTimeFragment() {
        let startTime = []
        let endTime = []
        let deadline = []

        this.couponData.forEach(item => {
          startTime.push(item.startTime)
          endTime.push(item.endTime)
          deadline.push(item.deadline)
        });
        return { startTime,endTime,deadline }
      },
      verifyParames() {
        let isPass = true
        let tispText = ``
        try {
          this.couponData.forEach((item,index)=> {
            for(let [key,value] of Object.entries(item)) {
              if (value == '') {
                isPass = false
                if (key == 'couponTickets' && !value.length) {
                  tispText = `优惠券场次${index + 1}设置需添加优惠券`
                } else {
                  tispText = `请完善优惠券场次${index + 1}设置`
                }
               
                throw new Error('false')
              } 
            }
          })
        } catch(e) {
          if (e == 'false' ) throw  e
        }
       
        if (!isPass) {
          
          this.$toast({
            duration: 4000,
            message: tispText,
          });
        }
        return isPass
      }
    }
  }
</script>

<style lang="stylus" scoped>
.reserve {
  .reserve-title {
    padding: 15px 0 0 15px;
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin: 15px 0;
    padding 1px
    background-color: #fff
    border-radius: 8px;
    .collapse-head {
      display: flex;
      padding: 10px 15px;
      padding-bottom: 6px;
      font-weight: bold;
      justify-content: space-between;
      .right {
        margin-right: 6px;
        color: #FF6B59;
      }
    }
    .coupon-box {
      margin: 14px;
      font-size: 12px;
      border-bottom: 1px solid #ebedf0;
      .head-box {
        display: flex;
        font-weight: bold;
        justify-content: space-between;
        .head-left {
          display: flex;
          .del {
            color: #FF6B59;
            margin-right: 10px;
          }
          .edit {
            color: #ff6b31;
          }
         
        }
      }
      .row {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        .key {
          width: 120px;
          color: #999999;
        }
        .value {
          flex: 1;
          color: #333333;
          text-align: right
        }
      }
    }
    .add-goods-btn {
      margin 12px
      padding 6px 0
      text-align: center
      color $mainTextColor
      font-size 12px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 4px
    }
    
  }
  .add-range-btn {
    margin 15px
    padding 10px 0
    text-align: center
    color $mainTextColor
    font-size 14px
    font-weight 600
    border 1px solid $mainTextColor
    border-radius 8px
  }
  .comContentMargin {
    margin: 10px 15px;
  }
}
</style>